
import { Component, mixins } from 'nuxt-property-decorator'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import {
  NeoSkeleton,
  NeoTable,
  NeoTableColumn,
  NeoTooltip,
} from '@kodadot1/brick'

import PrefixMixin from '@/utils/mixins/prefixMixin'
import { sanitizeIpfsUrl } from '@/utils/ipfs'

import salesFeedGql from '@/queries/rmrk/subsquid/salesFeed.graphql'

import { RowSales } from './types'

const components = {
  Identity: () => import('@/components/identity/IdentityIndex.vue'),
  Money: () => import('@/components/shared/format/Money.vue'),
  Loader: () => import('@/components/shared/Loader.vue'),
  BasicImage: () => import('@/components/shared/view/BasicImage.vue'),
  BasicPopup: () => import('@/components/shared/view/BasicPopup.vue'),
  BlockExplorerLink: () => import('@/components/shared/BlockExplorerLink.vue'),
  NeoSkeleton,
  NeoTable,
  NeoTableColumn,
  NeoTooltip,
}

@Component({ components })
export default class SalesTable extends mixins(PrefixMixin) {
  public data: RowSales[] = []

  async fetch() {
    await this.fetchSalesFeed()
  }

  protected parseDate(ts: number): string {
    return new Date(ts).toLocaleString('en-GB', {
      timeZone: 'UTC',
      timeZoneName: 'short',
    })
  }

  public async fetchSalesFeed() {
    const {
      data: { salesFeed },
    } = await this.$apollo.query({
      query: salesFeedGql,
      client: this.client,
      variables: {},
    })

    salesFeed.forEach((nft, idx) => {
      nft.idx = idx + 1
      nft.image = sanitizeIpfsUrl(nft.image)
      nft.date = this.parseDate(Number(nft.timestamp))
      nft.relDate = formatDistanceToNow(Number(nft.timestamp), {
        addSuffix: true,
      })
    })

    this.data = salesFeed
  }
}
